export default __webpack_public_path__ + "static/media/workshop24-responsivo.71ba1096.png";